<template>
    <div class="edit-pages-supporters-form">
        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <div class="content">
                <b-form-group label="Título principal" label-for="title">
                    <b-form-textarea
                        id="title"
                        name="title"
                        v-model="form.title"
                        placeholder="Descreva aqui."
                        rows="6"
                    ></b-form-textarea>
                </b-form-group>

                <b-button class="radius-6" :variant="'outline-primary'" @click="showModal('add-supporter-modal-ref')">
                    Adicionar apoiador
                </b-button>

                <div class="supporter" v-for="(supporter, index) in form.supporters" :key="index">
                    <div class="delete" @click="showModal('warning-remove-supporter-modal-ref')">Excluir</div>

                    <b-form-group label="Nome do apoiador" :label-for="`supporter-${index}`">
                        <b-form-input
                            :id="`supporter-${index}`"
                            :name="`supporter-${index}`"
                            v-model="supporter.name"
                            placeholder="Digite aqui."
                        ></b-form-input>
                    </b-form-group>

                    <FormFilePP
                        :label="'Banner principal'"
                        :text1="textFile1"
                        :text2="textFile2"
                        :accept="'image/jpeg, image/jpg, image/png'"
                        :singleFile="true"
                        :previewImg="true"
                    />
                </div>
            </div>

            <div class="footer-buttons">
                <hr class="line" />

                <b-button type="submit" class="radius-6 submit" :variant="'primary'">
                    Alterar
                </b-button>
            </div>
        </b-form>

        <b-modal
            ref="add-supporter-modal-ref"
            title="Adicionar apoiador"
            size="lg"
            cancel-title="Cancelar"
            ok-title="Adicionar"
            ok-variant="primary"
            @ok="addSupporter"
            :ok-disabled="!addSupporterForm.name"
            :modal-class="`alter-profile-modal ${getIsDarkTheme ? 'dark-theme' : ''}`"
        >
            <b-form>
                <b-form-group label="Nome do apoiador" :label-for="`supporter-modal`">
                    <b-form-input
                        :id="`supporter-modal`"
                        :name="`supporter-modal`"
                        v-model="addSupporterForm.name"
                        placeholder="Digite aqui."
                    ></b-form-input>
                </b-form-group>

                <b-form-group>
                    <FormFilePP
                        :label="'Banner principal'"
                        :text1="textFile1"
                        :text2="textFile2"
                        :accept="'image/jpeg, image/jpg, image/png'"
                        :singleFile="true"
                        :previewImg="true"
                    />
                </b-form-group>
            </b-form>
        </b-modal>

        <b-modal
            ref="warning-remove-supporter-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <WarningMsgModal :msg="warningMessage" />
            </div>

            <div class="footer-buttons">
                <b-button variant="danger" @click="removeSupporter()">Sim, excluir</b-button>

                <b-button variant="secondary" @click="hideModal('warning-remove-supporter-modal-ref')">
                    Cancelar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import FormFilePP from '@/ui/form-file-pp/FormFilePP'
import WarningMsgModal from '@/ui/modal/warning-msg-modal/WarningMsgModal'

export default {
    name: 'EditPagesSupportersForm',
    components: { FormFilePP, WarningMsgModal },
    data() {
        return {
            warningMessage: 'Tem certeza que deseja excluir o apoiador do site?',
            form: {
                title: null,
                supporters: [
                    {
                        name: null,
                        file: null
                    }
                ]
            },
            addSupporterForm: {
                name: null,
                file: null
            },
            textFile1: 'Tamanho de upload de imagem para 2 Mb',
            textFile2: 'Arquivos suportados: .png. e, .jpg'
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        }
    },
    methods: {
        onSubmit() {
            // console.log('submit >>>', this.form)
        },
        addSupporter() {
            this.form.supporters.push({
                name: this.addSupporterForm.name,
                file: null
            })

            this.hideModal('add-supporter-modal-ref')
        },
        removeSupporter(index) {
            this.hideModal('warning-remove-supporter-modal-ref')
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        }
    }
}
</script>

<style scope src="./EditPagesSupportersForm-light-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-admin-grid-page/edit-pages-admin/edit-pages-supporters-form/EditPagesSupportersForm.vue